const theme = {
  colors: {
    primary: '#00d592', // Green from the logo
    secondary: '#333740', // Dark gray from the logo
    background: '#f8f9fa', // Light background
    white: '#ffffff',
    gray: '#6c757d',
    lightGray: '#e9ecef',
    dark: '#343a40',
    success: '#28a745',
    danger: '#dc3545',
  },
  fonts: {
    primary: '"Poppins", sans-serif',
  },
  breakpoints: {
    xs: '480px',
    sm: '768px',
    md: '992px',
    lg: '1200px',
  },
  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  borderRadius: '8px',
  transition: 'all 0.3s ease',
};

export default theme;